var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.632 0H0V39.954L188.632 163.54V0Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 136.598V188.632H79.419L0 136.598Z",
    fill: "#41479B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 323.369V375.402L79.419 323.369H0Z",
    fill: "#41479B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 39.954V0H323.368V163.54L512 39.954Z",
    fill: "#41479B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 375.402V323.369H432.581L512 375.402Z",
    fill: "#41479B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M323.368 348.46V512H512V472.046L323.368 348.46Z",
    fill: "#41479B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M512 188.632V136.598L432.581 188.632H512Z",
    fill: "#41479B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 472.046V512H188.632V348.46L0 472.046Z",
    fill: "#41479B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M512 472.046V432.118L344.465 323.369H393.961L512 399.989V375.402L432.581 323.369H512V296.421H296.421V512H323.368V348.46L512 472.046Z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 296.421V323.369H79.419L0 375.402V413.203L138.395 323.369H187.891L0 445.332V472.046L188.632 348.46V512H215.579V296.421H0Z",
    fill: "#F5F5F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.579 0H188.632V163.54L0 39.954V83.679L161.684 188.632H112.188L0 115.807V136.598L79.419 188.632H0V215.579H215.579V0Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M512 215.579V188.632H432.581L512 136.598V98.314L372.864 188.632H323.368L512 66.185V39.954L323.368 163.54V0H296.421V215.579H512Z",
    fill: "#F5F5F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M512 296.421V215.579H296.421V0H215.579V215.579H0V296.421H215.579V512H296.421V296.421H512Z",
    fill: "#FF4B55"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.395 323.369L0 413.203V445.332L187.891 323.369H138.395Z",
    fill: "#FF4B55"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M344.465 323.369L512 432.118V399.989L393.961 323.369H344.465Z",
    fill: "#FF4B55"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M161.684 188.632L0 83.679V115.807L112.188 188.632H161.684Z",
    fill: "#FF4B55"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M372.864 188.632L512 98.3141V66.1851L323.368 188.632H372.864Z",
    fill: "#FF4B55"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/EN.e52f9594615ef89ed6a0426e72fecf63.svg";
export { ForwardRef as ReactComponent };